import React from 'react';
import {
    CardFooter,
    Brands,
    BrandLabel,
    BrandsName,
    Status,
    StatusText,
    RowContainer,
    StatusName,
    ReservationText,
    SetCount, 
    EAStatus,
    Type,
    SetName,
    EAStatusText,
    ColumnContainer,
    UserAndFavoritesContainer,
    UserNameAndDateContainer,
    FavoriteIconContainer,
    Icon,
    Flex
} from '../SetsAndItems.styled';
import { useTranslation } from 'react-i18next';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { getDisplayDateTime,getBrowserTimeZoneName} from '../../../../utils/dateUtils';
import ReservationRequired from 'src/assets/images/Menu/ReservationRequired.svg';
import { Box } from '@material-ui/core';
import { DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, 
    LIST_VIEW_TABLE_CELL } from '../../../../styles/fonts/MCFontConstants';

const CardFooterContainer = (props) => {
    const {
        isReservationSet = false,
        cartFooterMargin,
        cardFooterWidth,
        isPlaceHolder,
        isPlaceHolderAdded,
        displayReservationMsg,
        isOrderDetail = false,
        home,
        brand,
        uom,
        showBrand,
        isEquity = false,
        enableTemplateCardSpecificStyling,
        isEquityOrder = false,
        type,
        isBundle = false,
        alignSelfBrand,
        isConsignmentAdd,
        orderType,
        cartPage,
        showType,
        showHome,
        showStatus,
        isSet,
        itemQuantity,
        quantity, 
        isEquityProductSearch = false,
        setNameColor,
        clickable,
        setNameFontSizeDesktop,
        setNameLetterSpacing,
        handleBundlePopup,
        onSetItemClick,
        setOrItemDetails,
        materialType, 
        isBundleSubItem = false,
        handleBundleSubItemDelete, 
        handleBundleDelete,
        handleDeleteProducts,
        moreTemplates,
        createdBy,
        CreatedByUser, 
        createdDate,
        favoriteOrUnfavorite,
        isFavourite = false,
        FavoriteActive,
        FavoriteInactive,
        isScheduleSurgery = false,
        status = '',
        isExtraItem = false,
        isEquityTemplate=false,
        mbFlexDirection,
        setFavoriteIconTop,
    }=props;
    
    const { t } = useTranslation();
  const displayDate =createdDate ? getDisplayDateTime(createdDate) : 'N/A';
                                  
    return (
           <CardFooter
            cartFooterMargin={!isReservationSet && cartFooterMargin}
            cardFooterWidth={cardFooterWidth}
            enableTemplateCardSpecificStyling={
                enableTemplateCardSpecificStyling
            }
            justifyContentWithoutBrand={!brand && (uom || type)}
            showBrand={showBrand ? true : false}
            cardFlexDirection={'column'}
            isEquity={isEquity}
            mbFlexDirection={mbFlexDirection}
        >
            {(isEquityOrder && !isBundle) && (
                <Flex  
                        width ='100%'
                        justifyContent='space-between'
                        flexDirection= 'column'
                >
                    {showBrand && brand && brand != '' ? (
                        <Brands alignSelf={alignSelfBrand} color={isConsignmentAdd ? LIST_VIEW_TABLE_CELL : undefined}>
                            <BrandLabel>
                            {isEquity ? t('equity.common.bundleItems.brand') : isConsignmentAdd 
                            ? t('ConsignmentAdd.common.setsAndItems.brand') 
                            : t('scheduleSurgery.surgery.notifications.itemListView.brands')}
                            </BrandLabel>
                            <BrandsName color={isConsignmentAdd ? DARK_NAVY_FONT_COLOR : undefined}
                                IsConsignmentBillingOrder={
                                    orderType == 'KE' ||
                                    orderType == 'ZKA'
                                }
                                isEquityOrder
                            >{`\u00A0${brand}`}</BrandsName>
                        </Brands>
                    ) : null}
                    {showType && !isSet && !(isEquityOrder && cartPage) && !isEquityProductSearch? (
                        <Status width='59px !important'> 
                            <StatusText>{uom || type}</StatusText>
                        </Status>
                    ) : null}
                    {(showStatus || showHome) ? (
                        <RowContainer contentPadding={'0px'}>
                            {showStatus? (
                                <Brands
                                    color={DARK_GRAY_FONT_COLOR}
                                    letterSpacing={'0px'}
                                    wordBreak={'break-all'}
                                >
                                    <BrandLabel>
                                    {t(
                                        'more.common.setsAndItems.status'
                                    )}
                                    </BrandLabel>
                                    <StatusName
                                        color={DARK_GRAY_FONT_COLOR}
                                        letterSpacing={'0px'}
                                        IsConsignmentBillingOrder={
                                            orderType == 'KE' ||
                                            orderType == 'ZKA'
                                        }
                                        isEquityOrder
                                    >
                                        {`\u00A0${status}`}
                                    </StatusName>{' '}
                                </Brands>
                            ) : null}
                            {showHome ? (
                                <Brands
                                    color={DARK_GRAY_FONT_COLOR}
                                    letterSpacing={'0px'}
                                    wordBreak={'break-all'}
                                >
                                    {t(
                                        'more.common.setsAndItems.home'
                                    )}
                                    <BrandsName
                                        color={DARK_GRAY_FONT_COLOR}
                                        letterSpacing={'0px'}
                                    >
                                        {`\u00A0${home}`}
                                    </BrandsName>{' '}
                                </Brands>
                            ) : null}
                        </RowContainer>
                    ) : null}
                </Flex>
            )}

            {isPlaceHolderAdded || isPlaceHolder ? (
                <BrandsName fontWeight={'bold'}>
                    {t(
                        'more.common.setsAndItems.setAddedToEnableUNIDPlanFee'
                    )}
                </BrandsName>
            ) : showBrand &&
            brand &&
            brand != '' &&
            !isEquityOrder ? (
                <Flex 
                        flexDirection= 'column'
                        width= { isReservationSet && '100%'} 
                >
                    {/* Brand for surgery */}
                    <Brands>
                        <BrandLabel>{t('more.common.setsAndItems.brand')}</BrandLabel>
                        <BrandsName>{`\u00A0${brand}`}</BrandsName>
                    </Brands>
                    {isReservationSet &&
                    isReservationSet !== undefined ? (
                        <Flex width= '100%'>
                            <img
                                src={ReservationRequired}
                                alt="ReservationRequired"
                                width="20px"
                                height="20px"
                                style={{ marginRight: '1%' }}
                            />
                            <ReservationText>
                                {t('common.reservationRequired')}
                            </ReservationText>
                        </Flex>
                    ) : null}
                </Flex>
            ) : null}
            {!brand &&
            displayReservationMsg &&
            isReservationSet &&
            isReservationSet !== undefined ? (
                <Flex width= '100%'>
                    <img
                        src={ReservationRequired}
                        alt="ReservationRequired"
                        width="20px"
                        height="20px"
                        style={{ marginRight: '1%' }}
                    />
                    <ReservationText>
                        {t('common.reservationRequired')}
                    </ReservationText>
                </Flex>
            ) : null}
            {itemQuantity && (
                <SetCount>
                    {isSet // not in con add, equity and template
                        ? <Type>{t('orders.shipTrackLabels.setLabel')}</Type>
                        : (
                            <>
                                {quantity} x
                                <Type>{uom || type}</Type>
                            </>
                        )
                    }
                </SetCount>
            )}

            {/*Added for equity  */}
            {
                (isEquity || isEquityOrder) &&
                <div
                    style={
                        isBundle
                        ? { display: 'flex', justifyContent: 'space-between', width: '100%'}
                        : undefined
                    }
                    >
                    {(isBundle && !isOrderDetail && !isEquityTemplate) ? 
                    <SetName
                        //onClick={() => {}}
                        color={setNameColor}
                        clickable={clickable}
                        fontSizeDesktop={setNameFontSizeDesktop}
                        fontSizeMobile={'12px'}
                        setNameLetterSpacing={setNameLetterSpacing}
                        enableTemplateCardSpecificStyling={
                            enableTemplateCardSpecificStyling
                        }
                        setNameWidth = '100%'
                        onClick={() => {
                            handleBundlePopup(setOrItemDetails);
                            onSetItemClick();
                        }}
                    >
                        {t(
                            'equity.common.bundleItems.additems'
                        )}
                    </SetName> : null}
                    {isEquityOrder && cartPage && !isEquityTemplate? (
                        <Box
                            id={`feesAndItems-deleteBox-${setOrItemDetails?.productKey || setOrItemDetails?.cfn || 'default'}`}
                            borderRadius={6}
                            border="1px solid #EBEBEB"
                            onClick={() =>
                                (materialType === 'ZKMT') || isBundleSubItem
                                    ? handleBundleSubItemDelete(true)
                                    : isBundle ? handleBundleDelete(true) 
                                    : handleDeleteProducts(true)
                            }
                            style={{
                                cursor: 'pointer',
                            }}
                        >
                            <img
                                src={DeleteLight}
                                style={{
                                    padding: '3px 4px 0px 3px',
                                }}
                            />
                        </Box>
                    ) : null}
                </div>      
            }
            
            {/* {showType && !isSet && !isEquityOrder ? ( */  } 
            {/* need for equity also */}
            {showType && !isSet && !(isEquityOrder && cartPage) && !isBundle? (
                isEquity || isConsignmentAdd || isEquityProductSearch || isScheduleSurgery || isOrderDetail
                || isEquityTemplate ? (
                    <EAStatus>
                        <EAStatusText>{uom || type}</EAStatusText>
                    </EAStatus>
                ) : (
                    <EAStatus>
                        <EAStatusText style={{fontSize : '12px'}}>{uom || type}</EAStatusText>
                    </EAStatus>
                )
            ) : null}

            {/* Set label for moreTemplates */}
            {isSet && moreTemplates ? (
                <EAStatus>
                    <EAStatusText style={{fontSize : '12px'}}>
                        {t('common.setLabel')}
                    </EAStatusText>
                </EAStatus>
            ) : null}

            {(showStatus || showHome) && !isExtraItem ? (
                <RowContainer contentPadding={'0px'}>
                    {showStatus ? (
                        <Brands
                            color={DARK_GRAY_FONT_COLOR}
                            letterSpacing={'0px'}
                            wordBreak={'break-all'}
                        >
                        {isEquity || isConsignmentAdd ? (
                                <BrandsName color={DARK_GRAY_FONT_COLOR} letterSpacing={'0px'}>
                                    {t('more.common.setsAndItems.status') + ' '}
                                </BrandsName>
                            ) : (
                                <BrandLabel>
                                    {t('orders.orderListView.statusLabel') + ':'}
                                </BrandLabel>
                            )}
                            <StatusName
                                color={DARK_GRAY_FONT_COLOR}
                                letterSpacing={'0px'}
                                IsConsignmentBillingOrder={
                                    orderType == 'KE'
                                }
                            >
                                {`\u00A0${status}`}
                            </StatusName>{' '}
                        </Brands>
                    ) : null}

                    {/* different in equity */}
                    {showHome ? (
                        <Brands
                            color={DARK_GRAY_FONT_COLOR}
                            letterSpacing={'0px'}
                            wordBreak={'break-all'}
                        >
                            {t('more.common.setsAndItems.home')}
                            <BrandsName
                                color={DARK_GRAY_FONT_COLOR}
                                letterSpacing={'0px'}
                            >
                                {`\u00A0${home}`}
                            </BrandsName>{' '}
                        </Brands>
                    ) : null}
                </RowContainer>
            ) : null}

            {createdBy ? (
                <RowContainer contentPadding={'0px'}>
                    <ColumnContainer>
                        <UserAndFavoritesContainer>
                            <Icon
                                id="created-by-user-icon"
                                mobilePath={CreatedByUser}
                                hideCursor={true}
                            />
                            <UserNameAndDateContainer>
                                <div className="userName">
                                    {createdBy}
                                </div>
                                <div className="dateStamp">
                                    {/* {getDisplayDate(createdDate)} */}
                                    {/* Added for template details date */}
                                    {displayDate} {getBrowserTimeZoneName()}
                                </div>
                            </UserNameAndDateContainer>
                        </UserAndFavoritesContainer>
                        {!setFavoriteIconTop && (
                            <FavoriteIconContainer
                                id="favorite-icon-container"
                                onClick={favoriteOrUnfavorite}
                                enableTemplateCardSpecificStyling={
                                    enableTemplateCardSpecificStyling
                                }
                                setFavoriteIconTop={setFavoriteIconTop}
                            >
                                <Icon
                                    id="favorite-icon"
                                    mobilePath={
                                        isFavourite
                                            ? FavoriteActive
                                            : FavoriteInactive
                                    }
                                />
                            </FavoriteIconContainer>
                        )}
                    </ColumnContainer>
                </RowContainer>
            ) : null}
        </CardFooter>
    );
};

export default CardFooterContainer;